module.exports = __webpack_public_path__ + "img/dcu-connection.da82807c.svg";